import Color from 'color';

const DEFAULT_SECONDARY_COLOR = '#413e3e';

export const setCSSCustomColorProperties = (colorGroup) => {
	const primaryColor = colorGroup.colors[0].hexCode;
	const primaryTransparent = Color(primaryColor).fade(0.2).string();
	let secondaryColor = colorGroup.colors[1].hexCode;
	const tertiaryColor = colorGroup.colors[2].hexCode;

	document.documentElement.style.setProperty(
		'--primary-color',
		primaryColor + '80',
	);
	document.documentElement.style.setProperty(
		'--primary-color-transparent',
		primaryTransparent,
	);

	if (!isGrey(secondaryColor)) {
		document.documentElement.style.setProperty(
			'--secondary-color',
			darkenColor(secondaryColor),
		);
	} else if (!isGrey(tertiaryColor)) {
		document.documentElement.style.setProperty(
			'--secondary-color',
			darkenColor(tertiaryColor),
		);
	} else {
		document.documentElement.style.setProperty(
			'--secondary-color',
			DEFAULT_SECONDARY_COLOR,
		);
	}

	document.documentElement.style.setProperty('--tertiary-color', tertiaryColor);
};

function isGrey(color) {
	const testColor = Color(color).rgb().array();
	if (testColor[0] === testColor[1] && testColor[1] === testColor[2])
		return true;
	return false;
}

// since this color goes against white, 0.3 luminosity is the correct contrast
function darkenColor(color) {
	let darkerColor = Color(color);
	while (darkerColor.luminosity() > 0.3) {
		darkerColor = darkerColor.darken(0.03).rgb();
	}
	return darkerColor.hex();
}

/* Set the default CSS variables that are used by ItemPreview component. */
export const setCSSCustomFontColorProperties = (brandFont, palette) => {
	document.documentElement.style.setProperty('--base-font', brandFont);
	setCSSCustomColorProperties(palette);
};

/* Creates a color group object for a company or user that can be used
to display colors for selection (see BbColors) or in setting CSS
color variables used by ItemPrevew (see CampaignEditorWorkspace). */
export const setCSSCustomUserOrCompanyColors = (palette, palleteName) => {
	const colors = [...palette]
		.filter((e) => e.name.indexOf('Color') !== -1)
		.map((e) => e.value);
	let colorsArray = [];

	if (colors.length >= 2 && colors.filter((e) => e.length > 0).length >= 2) {
		colorsArray = [
			{
				colorId: 1,
				colorType: 'Primary',
				hexCode: colors[0],
				paletteId: 0,
			},
			{
				colorId: 2,
				colorType: 'Secondary',
				hexCode: colors[1],
				paletteId: 0,
			},
			{
				colorId: 3,
				colorType: 'Tertiary',
				hexCode: colors[2],
				paletteId: 0,
			},
		];
	}

	return {
		colors: colorsArray,
		paletteId: 0,
		name: palleteName,
		show: colors.length >= 2,
	};
};
